import React, { Fragment } from 'react';
import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from './TextField';

class Alert extends React.Component {
    state = {
        inputValue: null
    };

    componentDidUpdate(prevProps) {
        if (prevProps.open && !this.props.open) {
            this.setState({ inputValue: null });
        }
    }

    render() {
        const {
            classes,
            open,
            onCancel,
            onAccept,
            title,
            message,
            acceptInput = false,
            placeholder = null
        } = this.props;
        const { inputValue } = this.state;

        return (
            <Dialog
                disableEscapeKeyDown
                open={open}
                onClose={(event, reason) => {
                    if (onCancel && reason === 'backdropClick') {
                        return;
                    }
                    onCancel && onCancel();
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                classes={{
                    paper: classes.viewRoot
                }}
            >
                <DialogTitle className={classes.header} id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <p>{message}</p>
                    {acceptInput && (
                        <TextField
                            multiline
                            placeholder={placeholder}
                            value={inputValue}
                            onChange={e => this.setState({ inputValue: e.target.value })}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    {onAccept ? (
                        <Fragment>
                            <Button onClick={onCancel} style={{ color: '#E64040' }}>
                                Cancel
                            </Button>
                            <Button onClick={() => onAccept(inputValue)} style={{ color: '#26CC6F' }} autoFocus>
                                Ok
                            </Button>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Button onClick={onCancel} color="primary" autoFocus>
                                Close
                            </Button>
                        </Fragment>
                    )}
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(theme => ({
    viewRoot: {
        margin: 32,
        width: 600,
        maxWidth: '100%',
        [theme.breakpoints.down('sm')]: {
            margin: 6
        }
    },
    header: {
        background: theme.palette.contentForeground[theme.funeralHome],
        color: '#FFFFFF',
        fontSize: '1.625rem',
        fontWeight: 'initial',
        lineHeight: 'normal',
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px'
        },
        '&>small': {
            fontSize: '16px',
            lineHeight: 'inherit'
        }
    }
}))(Alert);

/*
export default withStyles({})(({ open, onCancel, onAccept, title, message }) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                {onAccept ? (
                    <Fragment>
                        <Button onClick={onCancel} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={onAccept} color="primary" autoFocus>
                            Ok
                        </Button>
                    </Fragment>
                ) : (
                    <Fragment>
                        <Button onClick={onCancel} color="primary" autoFocus>
                            Close
                        </Button>
                    </Fragment>
                )}
            </DialogActions>
        </Dialog>
    );
});
*/
